/* BRUMAVA theme JS: reveal animations, PDP gallery, variant price, sticky ATC */
(function () {
  // Reveal on scroll
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

  // PDP: thumbnail gallery
  var main = document.querySelector('[data-main-img]');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.src = t.dataset.full;
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
    });
  });

  // PDP: variant change -> update hidden id + price
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var idInput = form.querySelector('input[name="id"]');
    var priceEls = document.querySelectorAll('[data-price]');
    form.querySelectorAll('input[data-variant-id]').forEach(function (r) {
      r.addEventListener('change', function () {
        idInput.value = r.dataset.variantId;
        if (r.dataset.price) priceEls.forEach(function (p) { p.textContent = r.dataset.price; });
        if (r.dataset.image) {
          var mi = document.querySelector('[data-main-img]');
          if (mi) mi.src = r.dataset.image;
          document.querySelectorAll('[data-thumb]').forEach(function (t) {
            t.classList.toggle('on', t.dataset.full === r.dataset.image);
          });
        }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = r.dataset.available === 'false'; btn.textContent = r.dataset.available === 'false' ? 'Agotado' : btn.dataset.label; }
      });
    });
  }

  // PDP: bundle selector (pack dúo) -> update quantity
  if (form) {
    var qtyInput = form.querySelector('[data-bundle-qty]');
    var bundleRadios = form.querySelectorAll('input[name="bundleqty"]');
    if (qtyInput && bundleRadios.length) {
      bundleRadios.forEach(function (r) {
        r.addEventListener('change', function () {
          qtyInput.value = r.value;
          form.querySelectorAll('.bundle-opt').forEach(function (o) {
            o.classList.toggle('on', o.contains(r));
          });
        });
      });
    }
  }

  // Sticky mobile add-to-cart
  var satc = document.querySelector('.satc');
  var buyBox = document.querySelector('.pdp-buy');
  if (satc && buyBox) {
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) { satc.classList.toggle('show', !e.isIntersecting); });
    }, { threshold: 0 });
    io2.observe(buyBox);
    satc.querySelector('button') && satc.querySelector('button').addEventListener('click', function () {
      var b = document.querySelector('[data-product-form] button[type="submit"]');
      if (b) b.click();
    });
  }
})();

/* Gallery slider: autoplay + dots */
(function () {
  var gal = document.querySelector('[data-gallery]');
  var dotsWrap = document.querySelector('[data-gallery-dots]');
  if (!gal || !dotsWrap) return;
  var items = gal.querySelectorAll('.gal-item');
  var dots = dotsWrap.querySelectorAll('button');
  var idx = 0, n = items.length, timer, interacting = false;

  function go(i, smooth) {
    idx = (i + n) % n;
    var item = items[idx];
    gal.scrollTo({ left: item.offsetLeft - (gal.clientWidth - item.clientWidth) / 2, behavior: smooth === false ? 'auto' : 'smooth' });
    dots.forEach(function (d, k) { d.classList.toggle('on', k === idx); });
  }
  dots.forEach(function (d, k) { d.addEventListener('click', function () { interacting = true; go(k); restart(); }); });
  gal.addEventListener('pointerdown', function () { interacting = true; clearInterval(timer); });
  gal.addEventListener('scroll', function () {
    clearTimeout(gal._t);
    gal._t = setTimeout(function () {
      var mid = gal.scrollLeft + gal.clientWidth / 2, best = 0, bd = 1e9;
      items.forEach(function (it, k) { var c = it.offsetLeft + it.clientWidth / 2, d = Math.abs(c - mid); if (d < bd) { bd = d; best = k; } });
      idx = best; dots.forEach(function (d, k) { d.classList.toggle('on', k === idx); });
    }, 80);
  });
  function restart() { clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 3500); }
  restart();
})();

/* Slider de reseñas (landing): autoplay + dots */
(function () {
  var sl = document.querySelector('[data-rv-slider]');
  var dotsWrap = document.querySelector('[data-rv-dots]');
  if (!sl || !dotsWrap) return;
  var items = sl.querySelectorAll('.rv-slide');
  var idx = 0, n = items.length, timer;
  for (var k = 0; k < n; k++) {
    var b = document.createElement('button');
    b.setAttribute('aria-label', 'Reseña ' + (k + 1));
    if (k === 0) b.className = 'on';
    (function (kk) { b.addEventListener('click', function () { go(kk); restart(); }); })(k);
    dotsWrap.appendChild(b);
  }
  var dots = dotsWrap.querySelectorAll('button');
  function go(i) {
    idx = (i + n) % n;
    var item = items[idx];
    sl.scrollTo({ left: item.offsetLeft - (sl.clientWidth - item.clientWidth) / 2, behavior: 'smooth' });
    dots.forEach(function (d, k2) { d.classList.toggle('on', k2 === idx); });
  }
  sl.addEventListener('pointerdown', function () { clearInterval(timer); });
  sl.addEventListener('scroll', function () {
    clearTimeout(sl._t);
    sl._t = setTimeout(function () {
      var mid = sl.scrollLeft + sl.clientWidth / 2, best = 0, bd = 1e9;
      items.forEach(function (it, k2) { var c = it.offsetLeft + it.clientWidth / 2, d = Math.abs(c - mid); if (d < bd) { bd = d; best = k2; } });
      idx = best; dots.forEach(function (d, k2) { d.classList.toggle('on', k2 === idx); });
    }, 80);
  });
  function restart() { clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 4200); }
  restart();
})();

/* Cookie banner: consent + Shopify Customer Privacy API */
(function () {
  var box = document.querySelector('[data-cookies]');
  if (!box) return;
  var KEY = 'brumava-consent';
  function apply(consent) {
    try {
      if (window.Shopify && Shopify.customerPrivacy) {
        Shopify.customerPrivacy.setTrackingConsent({ analytics: consent, marketing: consent, preferences: consent, sale_of_data: consent }, function () {});
      } else if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (e) {
          if (!e && Shopify.customerPrivacy) Shopify.customerPrivacy.setTrackingConsent({ analytics: consent, marketing: consent, preferences: consent, sale_of_data: consent }, function () {});
        });
      }
    } catch (err) {}
  }
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  if (saved === null) { box.hidden = false; } else { apply(saved === 'all'); }
  box.querySelector('[data-cookies-accept]').addEventListener('click', function () {
    try { localStorage.setItem(KEY, 'all'); } catch (e) {}
    apply(true); box.hidden = true;
  });
  box.querySelector('[data-cookies-decline]').addEventListener('click', function () {
    try { localStorage.setItem(KEY, 'essential'); } catch (e) {}
    apply(false); box.hidden = true;
  });
})();

/* Ventisca global: nieve fija sobre toda la landing, viento por cursor y scroll */
(function () {
  var cv = document.querySelector('[data-blizzard]');
  if (!cv) return;
  var ctx = cv.getContext('2d');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var W, H, flakes = [], wind = 0, windTarget = 0, lastScroll = window.scrollY;

  function size() {
    W = cv.width = window.innerWidth;
    H = cv.height = window.innerHeight;
  }
  size();
  window.addEventListener('resize', size);

  var N = window.innerWidth < 700 ? 45 : 95;
  for (var i = 0; i < N; i++) {
    flakes.push({
      x: Math.random() * 2200, y: Math.random() * 1400,
      r: 0.7 + Math.random() * 2.6,
      vy: 0.2 + Math.random() * 0.8,
      ph: Math.random() * Math.PI * 2,
      blue: Math.random() < 0.45
    });
  }

  window.addEventListener('pointermove', function (e) {
    windTarget = (e.clientX / window.innerWidth - 0.5) * 5;
  }, { passive: true });
  window.addEventListener('scroll', function () {
    var d = window.scrollY - lastScroll;
    lastScroll = window.scrollY;
    windTarget += Math.max(-4, Math.min(4, d * 0.06));
  }, { passive: true });

  var t = 0;
  function frame() {
    t += 0.01;
    wind += (windTarget - wind) * 0.04;
    windTarget *= 0.985;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < flakes.length; i++) {
      var f = flakes[i];
      f.y += f.vy * (reduced ? 0 : 1);
      f.x += (wind * (f.r / 3) + Math.sin(t * 2 + f.ph) * 0.35) * (reduced ? 0 : 1);
      if (f.y > H + 6) { f.y = -6; f.x = Math.random() * W; }
      if (f.x > W + 6) f.x = -6;
      if (f.x < -6) f.x = W + 6;
      ctx.beginPath();
      ctx.arc(f.x % (W + 12), f.y, f.r, 0, 6.2832);
      ctx.fillStyle = f.blue ? 'rgba(143,212,255,' + (0.16 + f.r / 11) + ')' : 'rgba(255,255,255,' + (0.22 + f.r / 9) + ')';
      ctx.fill();
    }
    if (!reduced) requestAnimationFrame(frame);
  }
  frame();
})();
